
const isProd = process.env.NODE_ENV === 'production'

if (isProd && window && window.fbq) {
  window.fbq('init', '2490063144343020')
  window.fbq('track', 'PageView')
}
